import { useEffect, useState, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api";
import { Modal } from "../components/ui";
import { STAGE_META, LEAD_STAGES, normStage, StageBadge } from "../components/leadStages";

const YEARS = (() => { const y = new Date().getFullYear(); return [y, y - 1, y - 2, y - 3]; })();

export default function Leads() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [leads, setLeads] = useState([]);
  const [q, setQ] = useState("");
  const [stageF, setStageF] = useState("");
  const [segF, setSegF] = useState("");
  const [modal, setModal] = useState(null); // {name,email,phone,note}
  const [checkupLeads, setCheckupLeads] = useState([]);
  const [showCheckup, setShowCheckup] = useState(false);
  const [followBusy, setFollowBusy] = useState(null);
  const [showCC, setShowCC] = useState(false);
  const [ccReport, setCcReport] = useState(null);

  const load = useCallback(() => {
    api.get("/pipeline").then((r) => setLeads(r.data)).catch(() => {});
    api.get("/pipeline?view=checkup_non_seguiti").then((r) => setCheckupLeads(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    api.get(`/pipeline/stats?year=${year}`).then((r) => setStats(r.data)).catch(() => {});
  }, [year, leads]);

  const markTest = async (leadId) => {
    if (!window.confirm("Escludere questo contatto dai conteggi del funnel? Verranno fermati anche gli invii.")) return;
    try {
      await api.post("/cambio-commercialista/prova", { lead_ids: [leadId], valore: true });
      const r = await api.get("/cambio-commercialista/report");
      setCcReport(r.data);
    } catch { /* niente */ }
  };

  const active = leads
    .filter((l) => !["vinto", "perso"].includes(normStage(l.stage)))
    .sort((a, b) => (b.updated_at || "").localeCompare(a.updated_at || ""));

  const filtered = leads.filter((l) => {
    const s = normStage(l.stage);
    if (stageF && s !== stageF) return false;
    if (segF && (l.segmento || "") !== segF) return false;
    if (q) {
      const t = q.toLowerCase();
      if (!(l.name || "").toLowerCase().includes(t) && !(l.email || "").toLowerCase().includes(t)) return false;
    }
    return true;
  });

  const createLead = async () => {
    try {
      const r = await api.post("/pipeline", { email: modal.email.trim() || null, name: modal.name.trim(), phone: modal.phone.trim() || null, note: modal.note.trim() || null });
      setModal(null); navigate(`/lead/${r.data.id}`);
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
  };

  const followLead = async (l) => {
    setFollowBusy(l.id);
    try { await api.post(`/pipeline/${l.id}/follow`); load(); }
    catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
    setFollowBusy(null);
  };

  const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");

  return (
    <div data-testid="leads-page">
      <h1 className="page-title">Lead</h1>
      <p className="page-sub">Il percorso di ogni potenziale cliente: dal primo contatto all'esito finale</p>

      <div className="toolbar">
        <label style={{ fontSize: 13 }}>Anno{" "}
          <select value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="leads-year">
            {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </label>
        <div className="spacer" />
        <button className={"btn" + (showCC ? " primary" : "")} onClick={() => { setShowCC(!showCC); if (!showCC && ccReport === null) api.get("/cambio-commercialista/report").then((r) => setCcReport(r.data)).catch(() => setCcReport([])); }} data-testid="cc-report-toggle">🔁 Funnel cambio commercialista</button>
        <button className="btn primary" onClick={() => setModal({ name: "", email: "", phone: "", note: "" })} data-testid="new-lead-btn">+ Nuovo lead</button>
      </div>

      {showCC && ccReport && (
        <div className="panel" data-testid="cc-report-panel">
          <h3 style={{ marginTop: 0 }}>🔁 Funnel cambio commercialista <span className="muted" style={{ fontSize: 12, fontWeight: 400 }}>· quale annuncio porta colloqui, non solo contatti</span></h3>
          {ccReport.length > 0 && (
            <p className="muted" style={{ fontSize: 12.5, marginTop: -6 }}>
              <strong style={{ color: "#fbbf24" }}>{ccReport.filter((r) => r.checklist_scaricata || r.prenota_aperta).length} contatti caldi</strong> (hanno scaricato la checklist o aperto la pagina di prenotazione) ·
              {" "}{ccReport.filter((r) => r.whatsapp === "sì").length} hanno chiesto WhatsApp ·
              {" "}{ccReport.filter((r) => r.consenso_contatto).length} con consenso al contatto su {ccReport.length}.
              {ccReport.filter((r) => r.risposta_wa).length > 0 && <> {" "}<strong style={{ color: "#22a35a" }}>{ccReport.filter((r) => r.risposta_wa).length} hanno risposto su WhatsApp</strong>.</>}
              Le aperture email non sono mostrate: Gmail carica le immagini da solo e falserebbe il dato.
            </p>
          )}
          {ccReport.length === 0 ? <p className="muted">Nessun contatto dal form per ora.</p> : (
            <table data-testid="cc-report-table">
              <thead><tr><th>Data</th><th>Denominazione</th><th>Forma giuridica</th><th>utm_content</th><th>Checklist</th><th>Pagina prenota</th><th>Clic</th><th>WhatsApp</th><th>Colloquio fissato</th><th>Preventivo inviato</th><th>Esito</th><th></th></tr></thead>
              <tbody>
                {ccReport.map((r) => (
                  <tr key={r.lead_id} data-testid={`cc-row-${r.lead_id}`}>
                    <td>{fmtDate(r.data)}</td>
                    <td><Link to={`/lead/${r.lead_id}`}>{r.denominazione}</Link>{r.telefono ? <><br /><span className="muted" style={{ fontSize: 11 }}>{r.telefono}{r.consenso_contatto ? " · consenso sì" : ""}</span></> : null}</td>
                    <td>{r.forma_giuridica}</td>
                    <td><strong>{r.utm_content}</strong></td>
                    <td>{r.checklist_scaricata ? "📥 sì" : "—"}</td>
                    <td>{r.prenota_aperta ? "🔥 sì" : "—"}</td>
                    <td>{r.clic > 0 ? r.clic : "—"}</td>
                    <td>{r.risposta_wa ? "✅ ha risposto" : r.whatsapp === "sì" ? "💬 chiede WhatsApp" : r.whatsapp === "no" ? "no grazie" : r.wa_inviato ? "📤 scritto" : r.wa_assente ? "✉️ email (no WhatsApp)" : "—"}</td>
                    <td>{r.colloquio_fissato ? "✅ sì" : "no"}</td>
                    <td>{r.preventivo_inviato ? "✅ sì" : "no"}</td>
                    <td>{r.esito}</td>
                    <td><button className="btn small" title="Escludilo dai conteggi del funnel" onClick={() => markTest(r.lead_id)} data-testid={`cc-mark-test-${r.lead_id}`}>🚫 prova</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {stats && (
        <div className="dash-cards" data-testid="leads-stats">
          <div className="dash-card"><div className="num" data-testid="stat-gestiti">{stats.gestiti}</div><div className="lbl">Lead gestiti nel {stats.year}</div></div>
          <div className="dash-card highlight"><div className="num" data-testid="stat-in-corso">{stats.in_corso}</div><div className="lbl">In corso adesso</div></div>
          <div className="dash-card"><div className="num" style={{ color: "#22a35a" }} data-testid="stat-clienti">{stats.clienti}</div><div className="lbl">Diventati clienti{stats.conversione_pct != null && <span className="lead-conv-pill" data-testid="stat-conversione">conversione {stats.conversione_pct}%</span>}</div></div>
          <div className="dash-card"><div className="num" style={{ color: "#c46b66" }} data-testid="stat-non-accettati">{stats.non_accettati}</div><div className="lbl">Non hanno accettato</div></div>
        </div>
      )}

      {active.length > 0 && (() => {
        const byStage = LEAD_STAGES.map((s) => ({ key: s, ...STAGE_META[s], n: active.filter((l) => normStage(l.stage) === s).length }));
        return (
          <div className="panel" data-testid="leads-progress-panel">
            <h3>Avanzamento dei lead in corso</h3>
            <div className="lead-flow" data-testid="lead-flow-bar">
              {byStage.map((s) => s.n > 0 && (
                <div key={s.key} className="lead-flow-seg" style={{ width: `${(s.n / active.length) * 100}%`, background: s.color }} title={`${s.label}: ${s.n}`}>
                  {s.n}
                </div>
              ))}
            </div>
            <div className="lead-flow-legend">
              {byStage.map((s, i) => (
                <div key={s.key} className="lead-flow-item" data-testid={`flow-stage-${s.key}`}>
                  <span className="dot" style={{ background: s.color }} />
                  <span className="flow-lbl">{i + 1}. {s.label}</span>
                  <span className="flow-n">{s.n}</span>
                  <span className="flow-pct">{active.length ? Math.round((s.n / active.length) * 100) : 0}%</span>
                </div>
              ))}
            </div>
            <p className="muted" style={{ fontSize: 12, marginTop: 10 }}>
              Nell'anno {stats?.year}: 📅 <strong>{stats?.appuntamenti ?? 0}</strong> appuntamenti svolti · 📄 <strong>{stats?.preventivi ?? 0}</strong> preventivi inviati
            </p>
          </div>
        );
      })()}

      {checkupLeads.length > 0 && (
        <div className="panel" style={{ borderColor: "rgba(14,116,144,.5)" }} data-testid="checkup-unfollowed-panel">
          <button onClick={() => setShowCheckup(!showCheckup)} data-testid="checkup-unfollowed-toggle"
            style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, textAlign: "left", color: "inherit" }}>
            <h3 style={{ margin: 0 }}>🩺 Check-up compilati, non ancora seguiti ({checkupLeads.length})</h3>
            <span className="spacer" style={{ flex: 1 }} />
            <span className="muted">{showCheckup ? "▲" : "▼"}</span>
          </button>
          <p className="muted" style={{ fontSize: 12.5, margin: "6px 0 0" }}>
            Sono in anagrafica e ricevono la loro sequenza email. Compariranno qui tra i lead solo se li segui tu (⭐) o quando prenotano un appuntamento.
          </p>
          {showCheckup && (
            <table style={{ marginTop: 10 }}>
              <thead><tr><th>Nome</th><th>Email</th><th>Compilato</th><th>Segmento</th><th>Sequenza email</th><th></th></tr></thead>
              <tbody>
                {checkupLeads.map((l) => (
                  <tr key={l.id} data-testid={`checkup-lead-row-${l.id}`}>
                    <td style={{ cursor: "pointer" }} onClick={() => navigate(`/lead/${l.id}`)}><strong>{l.name || "—"}</strong></td>
                    <td>{l.email || l.phone || "—"}</td>
                    <td className="muted" style={{ fontSize: 12 }}>{l.data_checkup ? l.data_checkup.split("-").reverse().join("/") : fmtDate(l.created_at)}</td>
                    <td className="muted" style={{ fontSize: 12 }}>{l.segmento || "—"}</td>
                    <td style={{ fontSize: 12, whiteSpace: "nowrap" }} data-testid={`checkup-seq-stats-${l.id}`}>
                      📤 {l.seq_inviate ?? 0} inviate
                      <span style={{ color: (l.seq_aperte ?? 0) > 0 ? "#22a35a" : "var(--muted, #94a3b8)" }}> · 👁 {l.seq_aperte ?? 0} aperte</span>
                      <span style={{ color: (l.seq_clic ?? 0) > 0 ? "#f59e0b" : "var(--muted, #94a3b8)" }}> · 🖱 {l.seq_clic ?? 0} clic</span>
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <button className="btn sm primary" onClick={() => followLead(l)} disabled={followBusy === l.id} data-testid={`checkup-follow-${l.id}`}>
                        {followBusy === l.id ? "…" : "⭐ Segui nel funnel"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <div className="panel" data-testid="leads-active-panel">
        <h3>🔥 In gestione adesso ({active.length})</h3>
        {active.length === 0 ? <p className="empty">Nessun lead in gestione attiva.</p> : (
          <div className="lead-cards">
            {active.map((l) => {
              const s = normStage(l.stage);
              const m = STAGE_META[s] || {};
              const idx = LEAD_STAGES.indexOf(s);
              const pct = idx >= 0 ? ((idx + 1) / LEAD_STAGES.length) * 100 : 0;
              return (
                <div key={l.id} className="lead-card" onClick={() => navigate(`/lead/${l.id}`)} data-testid={`lead-card-${l.id}`} style={{ borderLeftColor: m.color }}>
                  <div className="lead-card-name">{l.name || l.email || l.phone}</div>
                  <div className="lead-card-email">{l.email || l.phone}</div>
                  <div style={{ marginTop: 8 }}><StageBadge stage={l.stage} /></div>
                  <div className="lead-progress" title={`Passo ${idx + 1} di ${LEAD_STAGES.length}`} data-testid={`lead-progress-${l.id}`}>
                    <span style={{ width: `${pct}%`, background: m.color }} />
                  </div>
                  {l.next_action && <div className="lead-card-next">→ {l.next_action}</div>}
                  <div className="lead-card-date">agg. {fmtDate(l.updated_at)}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="panel">
        <h3>Tutti i lead ({filtered.length})</h3>
        <div className="toolbar" style={{ marginTop: 8 }}>
          <input placeholder="Cerca nome o email…" value={q} onChange={(e) => setQ(e.target.value)} style={{ maxWidth: 260 }} data-testid="leads-search" />
          <select value={stageF} onChange={(e) => setStageF(e.target.value)} data-testid="leads-stage-filter">
            <option value="">— tutte le fasi —</option>
            {Object.entries(STAGE_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
          </select>
          {leads.some((l) => l.segmento) && (
            <select value={segF} onChange={(e) => setSegF(e.target.value)} data-testid="leads-segment-filter">
              <option value="">— tutti i segmenti —</option>
              {[...new Set(leads.map((l) => l.segmento).filter(Boolean))].sort().map((sg) => <option key={sg} value={sg}>{sg}</option>)}
            </select>
          )}
        </div>
        {filtered.length === 0 ? <p className="empty">Nessun lead trovato.</p> : (
          <table>
            <thead><tr><th>Nome</th><th>Email</th><th>Fase</th><th>Segmento</th><th>Scadenza leva</th><th>Prossimo passo</th><th>Fonte</th><th>Aggiornato</th></tr></thead>
            <tbody>
              {filtered.map((l) => (
                <tr key={l.id} onClick={() => navigate(`/lead/${l.id}`)} style={{ cursor: "pointer" }} data-testid={`lead-row-${l.id}`}>
                  <td><strong>{l.name || "—"}</strong></td>
                  <td>{l.email || l.phone || "—"}</td>
                  <td><StageBadge stage={l.stage} /></td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.segmento || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.prossima_scadenza ? l.prossima_scadenza.split("-").reverse().join("/") : "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.next_action || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.source || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmtDate(l.updated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <Modal title="Nuovo lead" onClose={() => setModal(null)}>
          <div className="field"><label>Nome e cognome</label><input value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} data-testid="lead-new-name" /></div>
          <div className="field"><label>Email (o solo telefono qui sotto)</label><input value={modal.email} onChange={(e) => setModal({ ...modal, email: e.target.value })} data-testid="lead-new-email" /></div>
          <div className="field"><label>Telefono (aggancia anche WhatsApp)</label><input value={modal.phone} onChange={(e) => setModal({ ...modal, phone: e.target.value })} data-testid="lead-new-phone" /></div>
          <div className="field"><label>Nota iniziale</label><textarea rows={2} value={modal.note} onChange={(e) => setModal({ ...modal, note: e.target.value })} data-testid="lead-new-note" /></div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setModal(null)}>Annulla</button>
            <button className="btn primary" onClick={createLead} disabled={!modal.email.trim() && !modal.phone.trim()} data-testid="lead-new-save">Crea lead</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
